import { doc, collection, query, where, getDocs, deleteDoc, getFirestore } from "firebase/firestore";
import { app } from "../config"

const db = getFirestore(app);

const deleteEOBusinessProfile = async (userId) => {
    try {
        // Step 1: Get all events created by the EO
        const eventsQuery = query(collection(db, "events"), where("userId", "==", userId));
        const eventsSnapshot = await getDocs(eventsQuery);

        // Step 2: Iterate over each event and delete related records in mpsEventRegistration
        const deleteEventPromises = eventsSnapshot.docs.map(async (eventDoc) => {
            const eventId = eventDoc.id;

            // Query for mpsEventRegistration records related to the event
            const registrationsQuery = query(
                collection(db, "mpsEventRegistration"),
                where("eventId", "==", eventId)
            );
            const registrationsSnapshot = await getDocs(registrationsQuery);

            // Delete all registrations for this event
            const deleteRegistrationPromises = registrationsSnapshot.docs.map((registrationDoc) =>
                deleteDoc(doc(db, "mpsEventRegistration", registrationDoc.id))
            );
            await Promise.all(deleteRegistrationPromises);

            // Delete the event itself
            await deleteDoc(doc(db, "events", eventId));
        });

        // Wait for all event deletions to complete
        await Promise.all(deleteEventPromises);

        // Step 3: Delete the EO business profile
        await deleteDoc(doc(db, "EO_BusinessProfiles", userId));

        // Step 4: Delete the user record from the "users" collection
        await deleteDoc(doc(db, "users", userId));

        console.log("Successfully deleted EO business profile, user record, and related records for userId:", userId);

        return true;
    } catch (error) {
        console.error("Error deleting EO business profile, user record, and related records:", error);
        return false;
    }
};

export { deleteEOBusinessProfile };
